<template>
    <div class="order-traveler-item">
        <div class="order-traveler-item__icon">
            <img src="./../../img/icons/icon-person.svg" class="included-item__icon">
        </div>
        <div class="order-traveler-item__text">
            <span class="order-traveler-item__title">{{ type }} {{ number }}</span>
            <span class="order-traveler-item__name" v-if="traveller" v-text="name"></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        number: {type: Number, default: ''},
        traveller: {type: Object, default: null}
    },
    data() {
        return {
            translations: APP_CONFIG.TRANSLATION.TRAVELLER,  
        }
    },
    computed: {
        name() {
            return (this.traveller) ? this.traveller.firstName + ' ' + this.traveller.lastName : '';
        },
        type() {
            if(this.traveller) {
                return (this.traveller.type === 'K') ? this.translations.child : this.translations.adult;
            }

            return null;
        }
    }
}
</script>

